import { createIntercom, useIntercom } from '@mathieustan/vue-intercom'
import { flatten } from 'flat'

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig()
    nuxtApp.vueApp.use(
        createIntercom({
            appId: 'axuajeid',
        }),
    )

    // console.log('config.public.tracking', config.public.tracking)

    if (!config.public.tracking) {
        console.info('💡 Tracking disabled in development')

        return {
            provide: {
                tracking: {
                    update: (data) => {},
                    event: (name, data) => {},
                },
            },
        }
    }

    const intercom = useIntercom()
    intercom.boot({
        api_base: 'https://api-iam.eu.intercom.io/',
    })

    nuxtApp.$event.$on('intercom:show', () => {
        // console.log('showing intercom')
        if (intercom.visible) {
            intercom.hide()
        } else {
            intercom.show()
        }
    })

    const { gtag } = useGtag()

    window.heap = window.heap || []
    heap.load = function (e, t) {
        ;(window.heap.appid = e), (window.heap.config = t = t || {})
        var r = document.createElement('script')
        ;(r.type = 'text/javascript'), (r.async = !0), (r.src = 'https://cdn.heapanalytics.com/js/heap-' + e + '.js')
        var a = document.getElementsByTagName('script')[0]
        a.parentNode.insertBefore(r, a)
        for (
            var n = function (e) {
                    return function () {
                        heap.push([e].concat(Array.prototype.slice.call(arguments, 0)))
                    }
                },
                p = [
                    'addEventProperties',
                    'addUserProperties',
                    'clearEventProperties',
                    'identify',
                    'resetIdentity',
                    'removeEventProperty',
                    'setEventProperties',
                    'track',
                    'unsetEventProperty',
                ],
                o = 0;
            o < p.length;
            o++
        )
            heap[p[o]] = n(p[o])
    }
    window.heap.load('2218445775')

    console.log('tracking plugin', intercom)

    function update(data) {
        if (!config.public.tracking) {
            return
        }

        nuxtApp.$axios.get('/actions/user-tracking-sign-up').then((res) => {
            intercom.update(res)

            res = flatten(res, {
                delimiter: '_',
            })

            for (let key in Object.keys(res)) {
                res[key.replace('company_company_', 'company_')] = res[key]
                delete res[key]
            }

            window.heap.addUserProperties(res)
            gtag('set', 'user_properties', res)
        })
    }

    function trackEvent(name, data) {
        if (!config.public.tracking) {
            return
        }

        try {
            intercom.trackEvent(name, data)
        } catch (error) {
            console.log(error)
        }

        window.heap.track(name, data)
        gtag('event', name, data)
    }

    return {
        provide: {
            tracking: {
                update,
                event: (name, data) => trackEvent(name, data),
            },
        },
    }
})
